import clsx from 'clsx';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { FadeIn } from 'components/common/FadeIn';
import Channel4 from '../../svg/AsSeenOn/Channel4.svg';
import FinancialTimes from '../../svg/AsSeenOn/FinancialTimes.svg';
import Sky from '../../svg/AsSeenOn/Sky.svg';
import TheGuardian from '../../svg/AsSeenOn/TheGuardian.svg';
import styles from './AsSeenOn.module.css';

const AsSeenOn = () => {
  return (
    <AboutUsModule background="grey" withNoTopPadding>
      <AboutUsSiteContainer styles2026>
        <div className={styles.asSeenOn}>
          <FadeIn onScroll={true}>
            <div className={clsx('daymadeTypographyMRegular', styles.title)}>
              As seen on
            </div>
          </FadeIn>
          <FadeIn onScroll={true} delay={0.1}>
            <div className={styles.channel4}>
              <Channel4 />
            </div>
          </FadeIn>
          <FadeIn onScroll={true} delay={0.2}>
            <div className={styles.sky}>
              <Sky />
            </div>
          </FadeIn>
          <FadeIn onScroll={true} delay={0.3}>
            <div className={styles.theGuardian}>
              <TheGuardian />
            </div>
          </FadeIn>
          <FadeIn onScroll={true} delay={0.4}>
            <div className={styles.financialTimes}>
              <FinancialTimes />
            </div>
          </FadeIn>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

export default AsSeenOn;
